import { create } from 'zustand';

interface StatusState {
  statuses: string[];
  setStatuses: (statuses: string[]) => void;
}

export const useStatusStore = create<StatusState>((set) => ({
  statuses: ['new', 'answered', 'completed', 'cancelled'],
  setStatuses: (statuses) => set({ statuses }),
}));